/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const EnumMaterialableType = {
    Document: 'document',
    Site: 'site'
};
export function EnumMaterialableTypeFromJSON(json) {
    return EnumMaterialableTypeFromJSONTyped(json, false);
}
export function EnumMaterialableTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function EnumMaterialableTypeToJSON(value) {
    return value;
}
